import { makeDataErrorMessages } from '@atlassian/amkt-common';
import { makeUserId } from '@atlassian/mpac-types';
import getSPI from '../services/SPI';
export const FETCH_CURRENT_USER_ID = 'USERS_FETCH_CURRENT_USER_ID';
export const RECEIVE_CURRENT_USER_ID = 'USERS_RECEIVE_CURRENT_USER_ID';
export const RECEIVE_CURRENT_USER_ID_ERROR = 'USERS_RECEIVE_CURRENT_USER_ID_ERROR';
const fetchCurrentUserId = () => ({
  type: FETCH_CURRENT_USER_ID
});
const receiveCurrentUserId = _ref => {
  let {
    currentUserId
  } = _ref;
  return {
    type: RECEIVE_CURRENT_USER_ID,
    currentUserId
  };
};
const receiveCurrentUserIdError = _ref2 => {
  let {
    dataErrorMessages
  } = _ref2;
  return {
    type: RECEIVE_CURRENT_USER_ID_ERROR,
    dataErrorMessages
  };
};
export const doRetrieveCurrentUserId = () => dispatch => {
  dispatch(fetchCurrentUserId());
  return new Promise((resolve, reject) => getSPI().getCurrentUser().then(currentUser => {
    const currentUserId = makeUserId(currentUser.atlassianAccountId);
    dispatch(receiveCurrentUserId({
      currentUserId
    }));
    resolve(currentUserId);
  }, error => {
    dispatch(receiveCurrentUserIdError({
      dataErrorMessages: makeDataErrorMessages([error])
    }));
    reject(error);
  }));
};